// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3CAN6","error":"Textarea_error__3Q1ZK","readonly":"Textarea_readonly__2rkUr","disabled":"Textarea_disabled__1ErVF"};